/*eslint-disable*/
// @ts-nocheck
/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { ProposalVotes } from "./proposal_votes";
export var protobufPackage = "tumelo.investor.v1";
export var ProxyIntermediary;
(function (ProxyIntermediary) {
    ProxyIntermediary[ProxyIntermediary["PROXY_INTERMEDIARY_INVALID"] = 0] = "PROXY_INTERMEDIARY_INVALID";
    ProxyIntermediary[ProxyIntermediary["PROXY_INTERMEDIARY_PROXYMITY"] = 1] = "PROXY_INTERMEDIARY_PROXYMITY";
    ProxyIntermediary[ProxyIntermediary["PROXY_INTERMEDIARY_PROXYEDGE"] = 2] = "PROXY_INTERMEDIARY_PROXYEDGE";
    ProxyIntermediary[ProxyIntermediary["PROXY_INTERMEDIARY_PROXYEXCHANGE"] = 3] = "PROXY_INTERMEDIARY_PROXYEXCHANGE";
    ProxyIntermediary[ProxyIntermediary["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ProxyIntermediary || (ProxyIntermediary = {}));
export function proxyIntermediaryFromJSON(object) {
    switch (object) {
        case 0:
        case "PROXY_INTERMEDIARY_INVALID":
            return ProxyIntermediary.PROXY_INTERMEDIARY_INVALID;
        case 1:
        case "PROXY_INTERMEDIARY_PROXYMITY":
            return ProxyIntermediary.PROXY_INTERMEDIARY_PROXYMITY;
        case 2:
        case "PROXY_INTERMEDIARY_PROXYEDGE":
            return ProxyIntermediary.PROXY_INTERMEDIARY_PROXYEDGE;
        case 3:
        case "PROXY_INTERMEDIARY_PROXYEXCHANGE":
            return ProxyIntermediary.PROXY_INTERMEDIARY_PROXYEXCHANGE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ProxyIntermediary.UNRECOGNIZED;
    }
}
export function proxyIntermediaryToJSON(object) {
    switch (object) {
        case ProxyIntermediary.PROXY_INTERMEDIARY_INVALID:
            return "PROXY_INTERMEDIARY_INVALID";
        case ProxyIntermediary.PROXY_INTERMEDIARY_PROXYMITY:
            return "PROXY_INTERMEDIARY_PROXYMITY";
        case ProxyIntermediary.PROXY_INTERMEDIARY_PROXYEDGE:
            return "PROXY_INTERMEDIARY_PROXYEDGE";
        case ProxyIntermediary.PROXY_INTERMEDIARY_PROXYEXCHANGE:
            return "PROXY_INTERMEDIARY_PROXYEXCHANGE";
        case ProxyIntermediary.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
/**
 * SplitVoteInstructionSubmissionAcknowledgementStatus defines the statuses of
 * a split vote instruction submission acknowledgement: ACCEPTED, REJECTED, CONFIRMED, OVERRIDDEN
 */
export var SplitVoteInstructionSubmissionAcknowledgementStatus;
(function (SplitVoteInstructionSubmissionAcknowledgementStatus) {
    SplitVoteInstructionSubmissionAcknowledgementStatus[SplitVoteInstructionSubmissionAcknowledgementStatus["SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_INVALID"] = 0] = "SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_INVALID";
    SplitVoteInstructionSubmissionAcknowledgementStatus[SplitVoteInstructionSubmissionAcknowledgementStatus["SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_ACCEPTED"] = 1] = "SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_ACCEPTED";
    SplitVoteInstructionSubmissionAcknowledgementStatus[SplitVoteInstructionSubmissionAcknowledgementStatus["SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_REJECTED"] = 2] = "SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_REJECTED";
    SplitVoteInstructionSubmissionAcknowledgementStatus[SplitVoteInstructionSubmissionAcknowledgementStatus["SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_CONFIRMED"] = 3] = "SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_CONFIRMED";
    SplitVoteInstructionSubmissionAcknowledgementStatus[SplitVoteInstructionSubmissionAcknowledgementStatus["SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_OVERRIDDEN"] = 4] = "SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_OVERRIDDEN";
    SplitVoteInstructionSubmissionAcknowledgementStatus[SplitVoteInstructionSubmissionAcknowledgementStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SplitVoteInstructionSubmissionAcknowledgementStatus || (SplitVoteInstructionSubmissionAcknowledgementStatus = {}));
export function splitVoteInstructionSubmissionAcknowledgementStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_INVALID":
            return SplitVoteInstructionSubmissionAcknowledgementStatus
                .SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_INVALID;
        case 1:
        case "SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_ACCEPTED":
            return SplitVoteInstructionSubmissionAcknowledgementStatus
                .SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_ACCEPTED;
        case 2:
        case "SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_REJECTED":
            return SplitVoteInstructionSubmissionAcknowledgementStatus
                .SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_REJECTED;
        case 3:
        case "SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_CONFIRMED":
            return SplitVoteInstructionSubmissionAcknowledgementStatus
                .SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_CONFIRMED;
        case 4:
        case "SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_OVERRIDDEN":
            return SplitVoteInstructionSubmissionAcknowledgementStatus
                .SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_OVERRIDDEN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SplitVoteInstructionSubmissionAcknowledgementStatus.UNRECOGNIZED;
    }
}
export function splitVoteInstructionSubmissionAcknowledgementStatusToJSON(object) {
    switch (object) {
        case SplitVoteInstructionSubmissionAcknowledgementStatus
            .SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_INVALID:
            return "SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_INVALID";
        case SplitVoteInstructionSubmissionAcknowledgementStatus
            .SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_ACCEPTED:
            return "SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_ACCEPTED";
        case SplitVoteInstructionSubmissionAcknowledgementStatus
            .SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_REJECTED:
            return "SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_REJECTED";
        case SplitVoteInstructionSubmissionAcknowledgementStatus
            .SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_CONFIRMED:
            return "SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_CONFIRMED";
        case SplitVoteInstructionSubmissionAcknowledgementStatus
            .SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_OVERRIDDEN:
            return "SPLIT_VOTE_INSTRUCTION_SUBMISSION_ACKNOWLEDGEMENT_STATUS_OVERRIDDEN";
        case SplitVoteInstructionSubmissionAcknowledgementStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseSplitVoteInstruction() {
    return {
        name: "",
        fundName: "",
        generalMeetingName: "",
        issuedInstrumentSecurityIdName: "",
        proxyIntermediaryBallotReference: undefined,
        votedFundVariantSecurityIdNames: [],
        totalVotes: 0,
        createTime: undefined,
        proposals: [],
        includesNonReportingHabitats: false,
        submissions: [],
        proxyIntermediaryBallotExternalId: "",
        contributingMeetingEntitlementsAndValidation: [],
        overwritten: false,
    };
}
export var SplitVoteInstruction = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = _m0.Writer.create(); }
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.fundName !== "") {
            writer.uint32(18).string(message.fundName);
        }
        if (message.generalMeetingName !== "") {
            writer.uint32(26).string(message.generalMeetingName);
        }
        if (message.issuedInstrumentSecurityIdName !== "") {
            writer.uint32(106).string(message.issuedInstrumentSecurityIdName);
        }
        if (message.proxyIntermediaryBallotReference !== undefined) {
            ProxyIntermediaryBallotReference.encode(message.proxyIntermediaryBallotReference, writer.uint32(98).fork())
                .ldelim();
        }
        for (var _i = 0, _a = message.votedFundVariantSecurityIdNames; _i < _a.length; _i++) {
            var v = _a[_i];
            writer.uint32(42).string(v);
        }
        if (message.totalVotes !== 0) {
            writer.uint32(49).double(message.totalVotes);
        }
        if (message.createTime !== undefined) {
            Timestamp.encode(toTimestamp(message.createTime), writer.uint32(58).fork()).ldelim();
        }
        for (var _b = 0, _c = message.proposals; _b < _c.length; _b++) {
            var v = _c[_b];
            SplitVoteInstructionProposal.encode(v, writer.uint32(66).fork()).ldelim();
        }
        if (message.includesNonReportingHabitats === true) {
            writer.uint32(72).bool(message.includesNonReportingHabitats);
        }
        for (var _d = 0, _e = message.submissions; _d < _e.length; _d++) {
            var v = _e[_d];
            SplitVoteInstructionSubmission.encode(v, writer.uint32(82).fork()).ldelim();
        }
        if (message.proxyIntermediaryBallotExternalId !== "") {
            writer.uint32(90).string(message.proxyIntermediaryBallotExternalId);
        }
        for (var _f = 0, _g = message.contributingMeetingEntitlementsAndValidation; _f < _g.length; _f++) {
            var v = _g[_f];
            SplitVoteInstructionMeetingEntitlementAndValidation.encode(v, writer.uint32(114).fork()).ldelim();
        }
        if (message.overwritten === true) {
            writer.uint32(120).bool(message.overwritten);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseSplitVoteInstruction();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.fundName = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.generalMeetingName = reader.string();
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.issuedInstrumentSecurityIdName = reader.string();
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.proxyIntermediaryBallotReference = ProxyIntermediaryBallotReference.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.votedFundVariantSecurityIdNames.push(reader.string());
                    continue;
                case 6:
                    if (tag !== 49) {
                        break;
                    }
                    message.totalVotes = reader.double();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.createTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.proposals.push(SplitVoteInstructionProposal.decode(reader, reader.uint32()));
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.includesNonReportingHabitats = reader.bool();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.submissions.push(SplitVoteInstructionSubmission.decode(reader, reader.uint32()));
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.proxyIntermediaryBallotExternalId = reader.string();
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.contributingMeetingEntitlementsAndValidation.push(SplitVoteInstructionMeetingEntitlementAndValidation.decode(reader, reader.uint32()));
                    continue;
                case 15:
                    if (tag !== 120) {
                        break;
                    }
                    message.overwritten = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            name: isSet(object.name) ? String(object.name) : "",
            fundName: isSet(object.fundName) ? String(object.fundName) : "",
            generalMeetingName: isSet(object.generalMeetingName) ? String(object.generalMeetingName) : "",
            issuedInstrumentSecurityIdName: isSet(object.issuedInstrumentSecurityIdName)
                ? String(object.issuedInstrumentSecurityIdName)
                : "",
            proxyIntermediaryBallotReference: isSet(object.proxyIntermediaryBallotReference)
                ? ProxyIntermediaryBallotReference.fromJSON(object.proxyIntermediaryBallotReference)
                : undefined,
            votedFundVariantSecurityIdNames: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.votedFundVariantSecurityIdNames)
                ? object.votedFundVariantSecurityIdNames.map(function (e) { return String(e); })
                : [],
            totalVotes: isSet(object.totalVotes) ? Number(object.totalVotes) : 0,
            createTime: isSet(object.createTime) ? fromJsonTimestamp(object.createTime) : undefined,
            proposals: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.proposals)
                ? object.proposals.map(function (e) { return SplitVoteInstructionProposal.fromJSON(e); })
                : [],
            includesNonReportingHabitats: isSet(object.includesNonReportingHabitats)
                ? Boolean(object.includesNonReportingHabitats)
                : false,
            submissions: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.submissions)
                ? object.submissions.map(function (e) { return SplitVoteInstructionSubmission.fromJSON(e); })
                : [],
            proxyIntermediaryBallotExternalId: isSet(object.proxyIntermediaryBallotExternalId)
                ? String(object.proxyIntermediaryBallotExternalId)
                : "",
            contributingMeetingEntitlementsAndValidation: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.contributingMeetingEntitlementsAndValidation)
                ? object.contributingMeetingEntitlementsAndValidation.map(function (e) {
                    return SplitVoteInstructionMeetingEntitlementAndValidation.fromJSON(e);
                })
                : [],
            overwritten: isSet(object.overwritten) ? Boolean(object.overwritten) : false,
        };
    },
    toJSON: function (message) {
        var _a, _b, _c, _d;
        var obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.fundName !== "") {
            obj.fundName = message.fundName;
        }
        if (message.generalMeetingName !== "") {
            obj.generalMeetingName = message.generalMeetingName;
        }
        if (message.issuedInstrumentSecurityIdName !== "") {
            obj.issuedInstrumentSecurityIdName = message.issuedInstrumentSecurityIdName;
        }
        if (message.proxyIntermediaryBallotReference !== undefined) {
            obj.proxyIntermediaryBallotReference = ProxyIntermediaryBallotReference.toJSON(message.proxyIntermediaryBallotReference);
        }
        if ((_a = message.votedFundVariantSecurityIdNames) === null || _a === void 0 ? void 0 : _a.length) {
            obj.votedFundVariantSecurityIdNames = message.votedFundVariantSecurityIdNames;
        }
        if (message.totalVotes !== 0) {
            obj.totalVotes = message.totalVotes;
        }
        if (message.createTime !== undefined) {
            obj.createTime = message.createTime.toISOString();
        }
        if ((_b = message.proposals) === null || _b === void 0 ? void 0 : _b.length) {
            obj.proposals = message.proposals.map(function (e) { return SplitVoteInstructionProposal.toJSON(e); });
        }
        if (message.includesNonReportingHabitats === true) {
            obj.includesNonReportingHabitats = message.includesNonReportingHabitats;
        }
        if ((_c = message.submissions) === null || _c === void 0 ? void 0 : _c.length) {
            obj.submissions = message.submissions.map(function (e) { return SplitVoteInstructionSubmission.toJSON(e); });
        }
        if (message.proxyIntermediaryBallotExternalId !== "") {
            obj.proxyIntermediaryBallotExternalId = message.proxyIntermediaryBallotExternalId;
        }
        if ((_d = message.contributingMeetingEntitlementsAndValidation) === null || _d === void 0 ? void 0 : _d.length) {
            obj.contributingMeetingEntitlementsAndValidation = message.contributingMeetingEntitlementsAndValidation.map(function (e) {
                return SplitVoteInstructionMeetingEntitlementAndValidation.toJSON(e);
            });
        }
        if (message.overwritten === true) {
            obj.overwritten = message.overwritten;
        }
        return obj;
    },
    create: function (base) {
        return SplitVoteInstruction.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var message = createBaseSplitVoteInstruction();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.fundName = (_b = object.fundName) !== null && _b !== void 0 ? _b : "";
        message.generalMeetingName = (_c = object.generalMeetingName) !== null && _c !== void 0 ? _c : "";
        message.issuedInstrumentSecurityIdName = (_d = object.issuedInstrumentSecurityIdName) !== null && _d !== void 0 ? _d : "";
        message.proxyIntermediaryBallotReference =
            (object.proxyIntermediaryBallotReference !== undefined && object.proxyIntermediaryBallotReference !== null)
                ? ProxyIntermediaryBallotReference.fromPartial(object.proxyIntermediaryBallotReference)
                : undefined;
        message.votedFundVariantSecurityIdNames = ((_e = object.votedFundVariantSecurityIdNames) === null || _e === void 0 ? void 0 : _e.map(function (e) { return e; })) || [];
        message.totalVotes = (_f = object.totalVotes) !== null && _f !== void 0 ? _f : 0;
        message.createTime = (_g = object.createTime) !== null && _g !== void 0 ? _g : undefined;
        message.proposals = ((_h = object.proposals) === null || _h === void 0 ? void 0 : _h.map(function (e) { return SplitVoteInstructionProposal.fromPartial(e); })) || [];
        message.includesNonReportingHabitats = (_j = object.includesNonReportingHabitats) !== null && _j !== void 0 ? _j : false;
        message.submissions = ((_k = object.submissions) === null || _k === void 0 ? void 0 : _k.map(function (e) { return SplitVoteInstructionSubmission.fromPartial(e); })) || [];
        message.proxyIntermediaryBallotExternalId = (_l = object.proxyIntermediaryBallotExternalId) !== null && _l !== void 0 ? _l : "";
        message.contributingMeetingEntitlementsAndValidation =
            ((_m = object.contributingMeetingEntitlementsAndValidation) === null || _m === void 0 ? void 0 : _m.map(function (e) {
                return SplitVoteInstructionMeetingEntitlementAndValidation.fromPartial(e);
            })) || [];
        message.overwritten = (_o = object.overwritten) !== null && _o !== void 0 ? _o : false;
        return message;
    },
};
function createBaseProxyIntermediaryBallotReference() {
    return { proxyIntermediary: 0, externalId: "" };
}
export var ProxyIntermediaryBallotReference = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = _m0.Writer.create(); }
        if (message.proxyIntermediary !== 0) {
            writer.uint32(8).int32(message.proxyIntermediary);
        }
        if (message.externalId !== "") {
            writer.uint32(18).string(message.externalId);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseProxyIntermediaryBallotReference();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.proxyIntermediary = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.externalId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            proxyIntermediary: isSet(object.proxyIntermediary) ? proxyIntermediaryFromJSON(object.proxyIntermediary) : 0,
            externalId: isSet(object.externalId) ? String(object.externalId) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.proxyIntermediary !== 0) {
            obj.proxyIntermediary = proxyIntermediaryToJSON(message.proxyIntermediary);
        }
        if (message.externalId !== "") {
            obj.externalId = message.externalId;
        }
        return obj;
    },
    create: function (base) {
        return ProxyIntermediaryBallotReference.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseProxyIntermediaryBallotReference();
        message.proxyIntermediary = (_a = object.proxyIntermediary) !== null && _a !== void 0 ? _a : 0;
        message.externalId = (_b = object.externalId) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseSplitVoteInstructionProposal() {
    return {
        id: undefined,
        proposalName: "",
        fundQuantifiedVoteName: "",
        investorVotes: undefined,
        splitVotes: undefined,
        splitVotesPercentage: undefined,
        contributingVoteResponseVersionIds: [],
    };
}
export var SplitVoteInstructionProposal = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = _m0.Writer.create(); }
        if (message.id !== undefined) {
            writer.uint32(58).string(message.id);
        }
        if (message.proposalName !== "") {
            writer.uint32(10).string(message.proposalName);
        }
        if (message.fundQuantifiedVoteName !== "") {
            writer.uint32(18).string(message.fundQuantifiedVoteName);
        }
        if (message.investorVotes !== undefined) {
            ProposalVotes.encode(message.investorVotes, writer.uint32(26).fork()).ldelim();
        }
        if (message.splitVotes !== undefined) {
            ProposalVotes.encode(message.splitVotes, writer.uint32(34).fork()).ldelim();
        }
        if (message.splitVotesPercentage !== undefined) {
            ProposalVotes.encode(message.splitVotesPercentage, writer.uint32(42).fork()).ldelim();
        }
        for (var _i = 0, _a = message.contributingVoteResponseVersionIds; _i < _a.length; _i++) {
            var v = _a[_i];
            writer.uint32(50).string(v);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseSplitVoteInstructionProposal();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.proposalName = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.fundQuantifiedVoteName = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.investorVotes = ProposalVotes.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.splitVotes = ProposalVotes.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.splitVotesPercentage = ProposalVotes.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.contributingVoteResponseVersionIds.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            id: isSet(object.id) ? String(object.id) : undefined,
            proposalName: isSet(object.proposalName) ? String(object.proposalName) : "",
            fundQuantifiedVoteName: isSet(object.fundQuantifiedVoteName) ? String(object.fundQuantifiedVoteName) : "",
            investorVotes: isSet(object.investorVotes) ? ProposalVotes.fromJSON(object.investorVotes) : undefined,
            splitVotes: isSet(object.splitVotes) ? ProposalVotes.fromJSON(object.splitVotes) : undefined,
            splitVotesPercentage: isSet(object.splitVotesPercentage)
                ? ProposalVotes.fromJSON(object.splitVotesPercentage)
                : undefined,
            contributingVoteResponseVersionIds: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.contributingVoteResponseVersionIds)
                ? object.contributingVoteResponseVersionIds.map(function (e) { return String(e); })
                : [],
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if (message.id !== undefined) {
            obj.id = message.id;
        }
        if (message.proposalName !== "") {
            obj.proposalName = message.proposalName;
        }
        if (message.fundQuantifiedVoteName !== "") {
            obj.fundQuantifiedVoteName = message.fundQuantifiedVoteName;
        }
        if (message.investorVotes !== undefined) {
            obj.investorVotes = ProposalVotes.toJSON(message.investorVotes);
        }
        if (message.splitVotes !== undefined) {
            obj.splitVotes = ProposalVotes.toJSON(message.splitVotes);
        }
        if (message.splitVotesPercentage !== undefined) {
            obj.splitVotesPercentage = ProposalVotes.toJSON(message.splitVotesPercentage);
        }
        if ((_a = message.contributingVoteResponseVersionIds) === null || _a === void 0 ? void 0 : _a.length) {
            obj.contributingVoteResponseVersionIds = message.contributingVoteResponseVersionIds;
        }
        return obj;
    },
    create: function (base) {
        return SplitVoteInstructionProposal.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d;
        var message = createBaseSplitVoteInstructionProposal();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : undefined;
        message.proposalName = (_b = object.proposalName) !== null && _b !== void 0 ? _b : "";
        message.fundQuantifiedVoteName = (_c = object.fundQuantifiedVoteName) !== null && _c !== void 0 ? _c : "";
        message.investorVotes = (object.investorVotes !== undefined && object.investorVotes !== null)
            ? ProposalVotes.fromPartial(object.investorVotes)
            : undefined;
        message.splitVotes = (object.splitVotes !== undefined && object.splitVotes !== null)
            ? ProposalVotes.fromPartial(object.splitVotes)
            : undefined;
        message.splitVotesPercentage = (object.splitVotesPercentage !== undefined && object.splitVotesPercentage !== null)
            ? ProposalVotes.fromPartial(object.splitVotesPercentage)
            : undefined;
        message.contributingVoteResponseVersionIds = ((_d = object.contributingVoteResponseVersionIds) === null || _d === void 0 ? void 0 : _d.map(function (e) { return e; })) || [];
        return message;
    },
};
function createBaseSplitVoteInstructionSubmission() {
    return {
        name: "",
        proxyIntermediaryBallotIdentifier: "",
        proxyIntermediaryName: "",
        submitTime: undefined,
        submittedBy: "",
        notes: "",
        acknowledgement: undefined,
        checkedBy: "",
        checkTime: undefined,
    };
}
export var SplitVoteInstructionSubmission = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = _m0.Writer.create(); }
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.proxyIntermediaryBallotIdentifier !== "") {
            writer.uint32(18).string(message.proxyIntermediaryBallotIdentifier);
        }
        if (message.proxyIntermediaryName !== "") {
            writer.uint32(74).string(message.proxyIntermediaryName);
        }
        if (message.submitTime !== undefined) {
            Timestamp.encode(toTimestamp(message.submitTime), writer.uint32(26).fork()).ldelim();
        }
        if (message.submittedBy !== "") {
            writer.uint32(34).string(message.submittedBy);
        }
        if (message.notes !== "") {
            writer.uint32(42).string(message.notes);
        }
        if (message.acknowledgement !== undefined) {
            SplitVoteInstructionSubmissionAcknowledgement.encode(message.acknowledgement, writer.uint32(50).fork()).ldelim();
        }
        if (message.checkedBy !== "") {
            writer.uint32(58).string(message.checkedBy);
        }
        if (message.checkTime !== undefined) {
            Timestamp.encode(toTimestamp(message.checkTime), writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseSplitVoteInstructionSubmission();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.proxyIntermediaryBallotIdentifier = reader.string();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.proxyIntermediaryName = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.submitTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.submittedBy = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.notes = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.acknowledgement = SplitVoteInstructionSubmissionAcknowledgement.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.checkedBy = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.checkTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            name: isSet(object.name) ? String(object.name) : "",
            proxyIntermediaryBallotIdentifier: isSet(object.proxyIntermediaryBallotIdentifier)
                ? String(object.proxyIntermediaryBallotIdentifier)
                : "",
            proxyIntermediaryName: isSet(object.proxyIntermediaryName) ? String(object.proxyIntermediaryName) : "",
            submitTime: isSet(object.submitTime) ? fromJsonTimestamp(object.submitTime) : undefined,
            submittedBy: isSet(object.submittedBy) ? String(object.submittedBy) : "",
            notes: isSet(object.notes) ? String(object.notes) : "",
            acknowledgement: isSet(object.acknowledgement)
                ? SplitVoteInstructionSubmissionAcknowledgement.fromJSON(object.acknowledgement)
                : undefined,
            checkedBy: isSet(object.checkedBy) ? String(object.checkedBy) : "",
            checkTime: isSet(object.checkTime) ? fromJsonTimestamp(object.checkTime) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.proxyIntermediaryBallotIdentifier !== "") {
            obj.proxyIntermediaryBallotIdentifier = message.proxyIntermediaryBallotIdentifier;
        }
        if (message.proxyIntermediaryName !== "") {
            obj.proxyIntermediaryName = message.proxyIntermediaryName;
        }
        if (message.submitTime !== undefined) {
            obj.submitTime = message.submitTime.toISOString();
        }
        if (message.submittedBy !== "") {
            obj.submittedBy = message.submittedBy;
        }
        if (message.notes !== "") {
            obj.notes = message.notes;
        }
        if (message.acknowledgement !== undefined) {
            obj.acknowledgement = SplitVoteInstructionSubmissionAcknowledgement.toJSON(message.acknowledgement);
        }
        if (message.checkedBy !== "") {
            obj.checkedBy = message.checkedBy;
        }
        if (message.checkTime !== undefined) {
            obj.checkTime = message.checkTime.toISOString();
        }
        return obj;
    },
    create: function (base) {
        return SplitVoteInstructionSubmission.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var message = createBaseSplitVoteInstructionSubmission();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.proxyIntermediaryBallotIdentifier = (_b = object.proxyIntermediaryBallotIdentifier) !== null && _b !== void 0 ? _b : "";
        message.proxyIntermediaryName = (_c = object.proxyIntermediaryName) !== null && _c !== void 0 ? _c : "";
        message.submitTime = (_d = object.submitTime) !== null && _d !== void 0 ? _d : undefined;
        message.submittedBy = (_e = object.submittedBy) !== null && _e !== void 0 ? _e : "";
        message.notes = (_f = object.notes) !== null && _f !== void 0 ? _f : "";
        message.acknowledgement = (object.acknowledgement !== undefined && object.acknowledgement !== null)
            ? SplitVoteInstructionSubmissionAcknowledgement.fromPartial(object.acknowledgement)
            : undefined;
        message.checkedBy = (_g = object.checkedBy) !== null && _g !== void 0 ? _g : "";
        message.checkTime = (_h = object.checkTime) !== null && _h !== void 0 ? _h : undefined;
        return message;
    },
};
function createBaseSplitVoteInstructionSubmissionAcknowledgement() {
    return { acknowledgeTime: undefined, status: 0, notes: "", createdBy: "", createTime: undefined };
}
export var SplitVoteInstructionSubmissionAcknowledgement = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = _m0.Writer.create(); }
        if (message.acknowledgeTime !== undefined) {
            Timestamp.encode(toTimestamp(message.acknowledgeTime), writer.uint32(10).fork()).ldelim();
        }
        if (message.status !== 0) {
            writer.uint32(16).int32(message.status);
        }
        if (message.notes !== "") {
            writer.uint32(26).string(message.notes);
        }
        if (message.createdBy !== "") {
            writer.uint32(34).string(message.createdBy);
        }
        if (message.createTime !== undefined) {
            Timestamp.encode(toTimestamp(message.createTime), writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseSplitVoteInstructionSubmissionAcknowledgement();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.acknowledgeTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.status = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.notes = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.createdBy = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.createTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            acknowledgeTime: isSet(object.acknowledgeTime) ? fromJsonTimestamp(object.acknowledgeTime) : undefined,
            status: isSet(object.status) ? splitVoteInstructionSubmissionAcknowledgementStatusFromJSON(object.status) : 0,
            notes: isSet(object.notes) ? String(object.notes) : "",
            createdBy: isSet(object.createdBy) ? String(object.createdBy) : "",
            createTime: isSet(object.createTime) ? fromJsonTimestamp(object.createTime) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.acknowledgeTime !== undefined) {
            obj.acknowledgeTime = message.acknowledgeTime.toISOString();
        }
        if (message.status !== 0) {
            obj.status = splitVoteInstructionSubmissionAcknowledgementStatusToJSON(message.status);
        }
        if (message.notes !== "") {
            obj.notes = message.notes;
        }
        if (message.createdBy !== "") {
            obj.createdBy = message.createdBy;
        }
        if (message.createTime !== undefined) {
            obj.createTime = message.createTime.toISOString();
        }
        return obj;
    },
    create: function (base) {
        return SplitVoteInstructionSubmissionAcknowledgement.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e;
        var message = createBaseSplitVoteInstructionSubmissionAcknowledgement();
        message.acknowledgeTime = (_a = object.acknowledgeTime) !== null && _a !== void 0 ? _a : undefined;
        message.status = (_b = object.status) !== null && _b !== void 0 ? _b : 0;
        message.notes = (_c = object.notes) !== null && _c !== void 0 ? _c : "";
        message.createdBy = (_d = object.createdBy) !== null && _d !== void 0 ? _d : "";
        message.createTime = (_e = object.createTime) !== null && _e !== void 0 ? _e : undefined;
        return message;
    },
};
function createBaseSplitVoteInstructionMeetingEntitlementAndValidation() {
    return { meetingEntitlementId: "", meetingEntitlementValidationId: "" };
}
export var SplitVoteInstructionMeetingEntitlementAndValidation = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = _m0.Writer.create(); }
        if (message.meetingEntitlementId !== "") {
            writer.uint32(10).string(message.meetingEntitlementId);
        }
        if (message.meetingEntitlementValidationId !== "") {
            writer.uint32(18).string(message.meetingEntitlementValidationId);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseSplitVoteInstructionMeetingEntitlementAndValidation();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.meetingEntitlementId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.meetingEntitlementValidationId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            meetingEntitlementId: isSet(object.meetingEntitlementId) ? String(object.meetingEntitlementId) : "",
            meetingEntitlementValidationId: isSet(object.meetingEntitlementValidationId)
                ? String(object.meetingEntitlementValidationId)
                : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.meetingEntitlementId !== "") {
            obj.meetingEntitlementId = message.meetingEntitlementId;
        }
        if (message.meetingEntitlementValidationId !== "") {
            obj.meetingEntitlementValidationId = message.meetingEntitlementValidationId;
        }
        return obj;
    },
    create: function (base) {
        return SplitVoteInstructionMeetingEntitlementAndValidation.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseSplitVoteInstructionMeetingEntitlementAndValidation();
        message.meetingEntitlementId = (_a = object.meetingEntitlementId) !== null && _a !== void 0 ? _a : "";
        message.meetingEntitlementValidationId = (_b = object.meetingEntitlementValidationId) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function toTimestamp(date) {
    var seconds = date.getTime() / 1000;
    var nanos = (date.getTime() % 1000) * 1000000;
    return { seconds: seconds, nanos: nanos };
}
function fromTimestamp(t) {
    var millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new globalThis.Date(o);
    }
    else {
        return fromTimestamp(Timestamp.fromJSON(o));
    }
}
function isSet(value) {
    return value !== null && value !== undefined;
}
